(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mus-home-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(slider) {
      if (slider.dataset.musInitialized) return;
      slider.dataset.musInitialized = 'true';
      var track = slider.querySelector('[data-mus-hero-track]');
      var slides = Array.from(slider.querySelectorAll('[data-mus-hero-slide]'));
      var dots = Array.from(slider.querySelectorAll('[data-mus-hero-dot]'));
      var pagination = slider.querySelector('.mus-hero-dots');
      if (!track || !slides.length) return;
      var index = Math.max(0, slides.findIndex(function (slide) {
        return slide.dataset.campaignId === slider.dataset.editorSlide;
      }));
      var timer;
      var scrollTimer;
      var frame;
      var hovered = false;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var controller = new AbortController();
      var options = { signal: controller.signal };
      var observer;

      function updateHeight() {
        track.style.height = Math.ceil(slides[index].getBoundingClientRect().height) + 'px';
      }

      function selectSlide(next) {
        index = Math.max(0, Math.min(next, slides.length - 1));
        slides.forEach(function (slide, i) {
          slide.inert = i !== index;
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        updateHeight();
      }

      function stop() {
        window.clearInterval(timer);
        timer = null;
      }

      function start() {
        stop();
        if (slider.dataset.autoplay !== 'true' || slides.length < 2 ||
            hovered || slider.contains(document.activeElement) ||
            document.hidden || reducedMotion.matches) return;
        timer = window.setInterval(function () {
          goTo((index + 1) % slides.length);
        }, Number(slider.dataset.autoplaySpeed) || 5000);
      }

      function goTo(next) {
        selectSlide(next);
        track.scrollTo({
          left: slides[index].offsetLeft,
          behavior: reducedMotion.matches ? 'instant' : 'smooth'
        });
        start();
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); }, options);
      });

      track.addEventListener('scroll', function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          if (!track.clientWidth) return;
          var nearest = Math.round(track.scrollLeft / track.clientWidth);
          selectSlide(nearest);
        }, 120);
      }, options);

      track.querySelectorAll('img').forEach(function (img) {
        img.addEventListener('load', updateHeight, options);
      });

      function resize() {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(function () {
          track.scrollTo({ left: slides[index].offsetLeft, behavior: 'instant' });
          updateHeight();
        });
      }

      if ('ResizeObserver' in window) {
        observer = new ResizeObserver(resize);
        slides.forEach(function (slide) {
          observer.observe(slide.querySelector('.mus-hero-layout'));
        });
      }
      window.addEventListener('resize', resize, options);
      slider.addEventListener('mouseenter', function () { hovered = true; stop(); }, options);
      slider.addEventListener('mouseleave', function () { hovered = false; start(); }, options);
      slider.addEventListener('focusin', stop, options);
      slider.addEventListener('focusout', function () {
        window.requestAnimationFrame(start);
      }, options);
      document.addEventListener('visibilitychange', start, options);
      reducedMotion.addEventListener('change', start, options);

      document.addEventListener('shopify:section:unload', function (event) {
        if (!event.target.contains(slider)) return;
        stop();
        window.clearTimeout(scrollTimer);
        window.cancelAnimationFrame(frame);
        if (observer) observer.disconnect();
        controller.abort();
      }, options);

      if (pagination) pagination.hidden = slides.length < 2;
      selectSlide(index);
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'instant' });
      start();
    }

    function init(root) {
      root.querySelectorAll('[data-mus-adaptive-slider]').forEach(initSlider);
    }

    init(document);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mus-trade-application"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.mus-trade-custom-form').forEach((form) => {
  if (form.dataset.initialized === 'true') return;
  form.dataset.initialized = 'true';

  const customerForm = document.getElementById('MusTradeCustomerNative');
  if (!customerForm) return;

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const panel = form.closest('.mus-trade-application__form-panel');
    const successTitle = panel ? panel.dataset.successTitle : 'Application received';
    const successBody = panel ? panel.dataset.successBody : 'Your application has been received.';
    const errorMessage = panel ? panel.dataset.errorMessage : 'We could not submit your application.';
    const status = form.querySelector('.mus-trade-status');
    const button = form.querySelector('.mus-trade-submit');
    const label = form.querySelector('.mus-trade-submit__label');
    const loading = form.querySelector('.mus-trade-submit__loading');
    const honeypot = form.querySelector('.mus-trade-honeypot');
    const email = form.querySelector('input[name="contact[email]"]');
    const customerEmail = customerForm.querySelector('input[name="contact[email]"]');

    status.hidden = true;
    status.className = 'mus-trade-status';

    if (honeypot && honeypot.value) {
      status.textContent = successTitle + ' — ' + successBody;
      status.classList.add('is-success');
      status.hidden = false;
      return;
    }

    customerEmail.value = email.value;

    button.disabled = true;
    label.hidden = true;
    loading.hidden = false;

    try {
      const customerResponse = await fetch(customerForm.action, {
        method: 'POST',
        body: new FormData(customerForm),
        credentials: 'same-origin'
      });

      if (!customerResponse.ok) {
        throw new Error(errorMessage);
      }

      const contactResponse = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin'
      });

      if (!contactResponse.ok) {
        throw new Error(errorMessage);
      }

      status.textContent = successTitle + ' — ' + successBody;
      status.classList.add('is-success');
      status.hidden = false;
      form.reset();
    } catch (error) {
      status.textContent = error.message || errorMessage;
      status.classList.add('is-error');
      status.hidden = false;
    } finally {
      button.disabled = false;
      label.hidden = false;
      loading.hidden = true;
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
